import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { motion } from 'framer-motion';
export function Process() {
  const {
    t
  } = useLanguage();
  const steps = t('process.steps');
  const easeOutCubic = [0.33, 1, 0.68, 1];
  return <section id="proceso" className="py-20 lg:py-28 bg-brand-cream relative overflow-hidden" data-id="element-283" data-mp="p1yscpubzhsh">
      <div className="container mx-auto px-6" data-id="element-284" data-mp="k1kmneg7cjxm">
        <div className="text-center max-w-2xl mx-auto mb-14" data-id="element-285" data-mp="3sip6js02h159">
          <span className="text-brand-dark/50 font-medium tracking-[0.25em] text-xs uppercase mb-6 block" data-id="element-286" data-mp="3nkdudamauejv">
            {t('process.eyebrow')}
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light text-brand-dark mb-6 tracking-tight" data-id="element-287" data-mp="65gstm98qdlo">
            {t('process.heading')}
          </h2>
          <p className="text-brand-dark/60 font-light text-lg" data-id="element-288" data-mp="39s7dtnf8i5jw">
            {t('process.subheading')}
          </p>
          <div className="w-12 h-px bg-brand-gold mx-auto mt-10" data-id="element-289" data-mp="34suuvdrhhiml"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 max-w-6xl mx-auto" data-id="element-290" data-mp="2mslgzb2748mi">
          {steps.map((step: any, idx: number) => <motion.div key={step.number} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.8,
          delay: idx * 0.15,
          ease: easeOutCubic
        }} className="relative" data-id="element-291" data-mp="2roscsb0vo3qq" data-mpi={idx}>
              {/* Step number */}
              <div className="mb-6 flex items-center gap-3" data-id="element-292" data-mp="2hua56uscbo1n">
                <span className="font-serif text-3xl text-brand-gold/80 font-light italic" data-id="element-293" data-mp="3o9atqff1d3y7">
                  {step.number}
                </span>
                <span className="flex-1 h-px bg-brand-stone" data-id="element-294" data-mp="3t619f1mxhxj3"></span>
              </div>

              <h3 className="font-serif text-2xl text-brand-dark font-light mb-3" data-id="element-295" data-mp="1t41pt2oya46d">
                {step.title}
              </h3>
              <p className="text-brand-dark/60 font-light leading-relaxed text-sm" data-id="element-296" data-mp="1p6dnvfoubb4z">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}